// lookup = (name) => returns <config>
const { Semantics, normalizeGenerator } = require('./semantics')
const { Generators } = require('./generators')
const { v4: uuidv4 } = require('uuid')
const configHelpers = require('./configHelpers')
const DigraphInternal = require('./digraph_internal')
const helpers = require('./helpers')
const { InitCalls } = require('./helpers')
const { ecatch } = require('./helpers')
const runtime = require('../runtime')
const _ = require('lodash')
const db = require('./debug')

const debugBreak = () => {
  // debugger
}

const bags = [
  'generators',
  'semantics'
]

const indent = (string, indent) => {
  return string.replace(/^/gm, ' '.repeat(indent))
}

const config_toServer = (config) => {
  // cant change things because copy breaks something
}

const updateHierarchy = (config) => {
  config.hierarchy = new DigraphInternal(config.config.hierarchy)
}

const initWords = (words) => {
  if (!words.literals) {
    words.literals = {}
  }
  if (!words.patterns) {
    words.patterns = []
  }
  if (!words.hierarchy) {
    words.hierarchy = []
  }
  return words
}

const debugPriority = (priority) => {
  if (global.pauseDebugging) {
    return
  }
  if (global.entodictonDebugPriority) {
    if (helpers.subPriority(entodictonDebugPriority, priority)) {
      // debug hierarchy hit
      debugger // eslint-disable-line no-debugger
    }
  }
}

const debugAssociation = (association) => {
  if (global.pauseDebugging) {
    return
  }
  if (global.entodictonDebugAssociation) {
    if (helpers.safeEquals(global.entodictonDebugAssociation, association)) {
      // debug association hit
      debugger // eslint-disable-line no-debugger
    }
  }
}

const debugWord = (word) => {
  if (global.pauseDebugging) {
    return
  }
  if (global.entodictonDebugWord) {
    if (helpers.safeEquals(global.entodictonDebugWord, word)) {
      // debug word hit
      debugger // eslint-disable-line no-debugger
    }
  }
}

const debugHierarchy = (pair) => {
  if (global.pauseDebugging) {
    return
  }
  if (global.entodictonDebugHierarchy) {
    if (helpers.safeEquals(global.entodictonDebugHierarchy, pair)) {
      // debug hierarchy hit
      debugger // eslint-disable-line no-debugger
    }
  }
}

const debugBridge = (bridge) => {
  if (global.pauseDebugging) {
    return
  }
  if (global.entodictonDebugBridge) {
    if (global.entodictonDebugBridge == bridge.id) {
      // debug hierarchy hit
      debugger // eslint-disable-line no-debugger
    }
  }
}

const debugOperator = (operator) => {
  if (global.pauseDebugging) {
    return
  }
  if (global.entodictonDebugOperator) {
    if ((operator.pattern || operator) === global.entodictonDebugOperator) {
      // debug operator hit
      debugger // eslint-disable-line no-debugger
    }
  }
}

const debugConfigProps = (config) => {
  if (global.pauseDebugging) {
    return
  }
  if (!config) {
    return
  }
  const checkProps = [
    { property: 'priorities', check: (v) => debugPriority(v) },
    { property: 'associations', check: (v) => debugAssociation(v) },
    // TODO implement debugWords
    { property: 'words', check: (v) => debugWords(v) },
    { property: 'hierarchy', check: (v) => debugHierarchy(v) },
    { property: 'operators', check: (v) => debugOperator(v) },
    { property: 'bridges', check: (v) => debugBridge(v) }
  ]
  for (const { property, check } of checkProps) {
    if (property == 'associations') {
      if (config[property]) {
        if (config[property].negative) {
          for (const value of config[property].negative) {
            check(value)
          }
        }
        if (config[property].positive) {
          for (const value of config[property].positive) {
            check(value)
          }
        }
      }
    } else if (property == 'words') {
      /*
      if (config[property]) {
        for (const value of config[property].literals) {
          check(value)
        }
      }
      */
    } else if (config[property]) {
      for (const value of config[property]) {
        check(value)
      }
    }
  }
}

const validConfigProps = (config) => {
  const valid = [
    'hierarchy',
    'objects',
    'bridges',
    'operators',
    'words',
    'priorities',
    'associations',
    'name',
    'version',
    'generatorp',
    'generators',
    'semantics',
    'where',
    'floaters',
    'debug',

    // TODO Fix these from the test app
    'implicits',
    'convolution',
    'expected_generated',
    'expected_results',
    'skipSemantics',
    'description',
    'contexts',
    'utterances',
    'flatten',

    'namespaces',
    'eqClasses'
  ]
  helpers.validProps(valid, config, 'config')

  // TODO add more type checks
  if (config.associations) {
    if (!config.associations.positive && !config.associations.negative) {
      throw new Error('Expected the \'associations\' property to be a hash with \'positive\' and or \'negative\' properties')
    }
  }
}

const setupInitializerFNArgs = (config, args) => {
  const aw = (word, def) => config.addWord(word, def, args.uuid)
  const ap = (pattern, def) => config.addPattern(pattern, def, args.uuid)
  const ag = (generator) => config.addGenerator(generator, args.uuid, config.name)
  const km = (name) => config.getConfig(name)
  const apis = (name) => config.getConfig(name).api

  return {
    ...args,
    addWord: aw,
    addPattern: ap,
    addGenerator: ag,
    config: config.getPseudoConfig(args.uuid, args.currentConfig),
    km,
    baseConfig: config,
    apis
  }
}

const operatorKey_valid = (key) => {
  if (
    !_.isArray(key) ||
        key.length != 2 ||
        !_.isString(key[0]) ||
        !_.isInteger(key[1]) ||
        key[1] < 0
  ) {
    let details = ''
    if (!_.isArray(key)) {
      details = 'Expected an array.'
    } else if (key.length != 2) {
      details = 'Expected an array of length two.'
    } else if (!_.isString(key[0])) {
      details = 'Expected element zero to be a string that is an operator id.'
    } else if (!_.isInteger(key[1])) {
      details = 'Expected element one to be a number that is an operator level.'
    } else if (key[1] < 0) {
      details = 'Expected element one to be a number that is an operator level which is greater than zero.'
    }
    throw new Error(`${JSON.stringify(key)} is not a valid operator key. Values are of the form [<operatorId>, <operatorLevel>]. ${details}`)
  }
}

const elist = (list, check, prefix) => {
  for ([index, element] of list.entries()) {
    try {
      check(element)
    } catch (e) {
      throw new Error(prefix(index, e))
    }
  }
}
const priorities_valid = (cps) => {
  elist(cps, (cp) => priority_valid(cp), (index, e) => `priorities has an invalid priority at position ${index}. ${e}`)
}

const priority_valid = (cp) => {
  if (!cp.context) {
    throw new Error(`The priority ${JSON.stringify(cp)} is missing the "context" property. That is a list of the operator keys that are to be prioritized differently.`)
  }
  if (!_.isArray(cp.context)) {
    throw new Error(`The priority ${JSON.stringify(cp)} has an invalid "context" value. That is a list of the operator keys that are to be prioritized differently.`)
  }
  elist(cp.context, (element) => operatorKey_valid(element), (index, e) => `The priority ${JSON.stringify(cp)} has an invalid operator key at position ${index}. ${e}`)
  if (!_.isArray(cp.choose)) {
    throw new Error(`The priority ${JSON.stringify(cp)} has an invalid "choose" value. The value should be a list of the operators in the context to consider for prioritization.`)
  }
  elist(cp.choose,
    (element) => {
      if (!element && element !== 0) {
        throw new Error('The value should be an index into the "context" property of the operator that is to be considered for prioritization.')
      }
      if (!_.isInteger(element) || element < 0 || element >= cp.context.length) {
        throw new Error(`The value should be an index into the "context" property of the operator that is to be considered for prioritization. Valid values are between 0 and ${cp.context.length - 1}.`)
      }
    },
    (index, e) => `The choose property in the priority ${JSON.stringify(cp)} has an invalid index at position ${index}. ${e}`
  )
}

const handleBridgeProps = (config, bridge, { addFirst, uuid } = {}) => {
  ecatch(`While processing the bridge for ${bridge.id}#${bridge.level}`,
    () => {
      if (bridge.development && config.isModule) {
        return
      }
      if (false && !bridge.bridge) {
        bridge.bridge = '{ ...next(operator) }'
      }
      if (!bridge.level) {
        bridge.level = 0
      }
      if (bridge.children) {
        for (const child of bridge.children) {
          if (child.child) {
            config.addHierarchy(child.child, bridge.id, child.instance)
          } else {
            config.addHierarchy(child, bridge.id)
          }
        }
      }
      if (bridge.operator) {
        config.addOperator(bridge.operator, uuid || config.uuid)
      }
      if (bridge.parents) {
        for (const parent of bridge.parents) {
          if (parent.parent) {
            config.addHierarchy(bridge.id, parent.parent, parent.instance)
          } else {
            config.addHierarchy(bridge.id, parent)
          }
        }
      }
      if (bridge.isA) {
        for (const parent of bridge.isA) {
          if (parent.parent) {
            config.addHierarchy(bridge.id, parent.parent, parent.instance)
          } else {
            config.addHierarchy(bridge.id, parent)
          }
        }
      }
      if (bridge.before) {
        for (let after of bridge.before) {
          if (typeof after === 'string') {
            after = [after, 0]
          }
          config.addPriority({ context: [[bridge.id, bridge.level], after], choose: [0] })
        }
      }
      if (bridge.after) {
        for (let before of bridge.after) {
          if (typeof before === 'string') {
            before = [before, 0]
          }
          config.addPriority({ context: [before, [bridge.id, bridge.level]], choose: [0] })
        }
      }
      if (bridge.words) {
        for (let def of bridge.words) {
          if (typeof def === 'string') {
            config.addWordInternal(def, { id: bridge.id, initial: `{ value: "${bridge.id}"}` })
          } else {
            const word = def.word
            def = { initial: JSON.stringify(def), id: bridge.id, word }
            config.addWordInternal(word, def)
          }
        }
      }
      /*
      if (bridge.generator) {
        if (addFirst) {
          config.config.generators.unshift(bridge.generator)
        } else {
          config.config.generators.push(bridge.generator)
        }
      }
      */

      const addUUID = (obj) => { return { ...obj, uuid: uuid || config.uuid } }

      if (bridge.generators) {
        const generators = [...bridge.generators]
        generators.reverse()
        for (const generator of generators) {
          if (addFirst) {
            config.config.generators.unshift(addUUID(generator))
          } else {
            config.config.generators.push(addUUID(generator))
          }
        }
      }
      if (bridge.generatorpr) {
        bridge.generatorp = bridge.generatorpr
        bridge.generatorr = bridge.generatorpr
      }
      if (bridge.generatorp) {
        const match = bridge.generatorp.match || (() => true)
        const apply = typeof bridge.generatorp === 'function' ? bridge.generatorp : bridge.generatorp.apply || bridge.generatorp
        const level = bridge.generatorp.level >= 0 ? bridge.generatorp.level : bridge.level + 1

        const generator = {
          where: bridge.generatorp.where || bridge.where || helpers.where(4),
          match: async (args) => bridge.id == args.context.marker && args.context.level == level && args.context.paraphrase && await match(args),
          apply: (args) => apply(args),
          applyWrapped: apply,
          property: 'generatorp'
        }
        if (addFirst) {
          config.config.generators.unshift(addUUID(generator))
        } else {
          config.config.generators.push(addUUID(generator))
        }
      }
      if (bridge.generatorr) {
        const match = bridge.generatorr.match || (() => true)
        const apply = typeof bridge.generatorr === 'function' ? bridge.generatorr : bridge.generatorr.apply || bridge.generatorr
        const level = bridge.generatorr.level >= 0 ? bridge.generatorr.level : bridge.level + 1
        const generator = {
          where: bridge.generatorr.where || bridge.where || helpers.where(4),
          match: async (args) => bridge.id == args.context.marker && args.context.level == level && !args.context.paraphrase && (args.context.response || args.context.isResponse) && await match(args),
          apply: (args) => apply(args),
          applyWrapped: apply,
          property: 'generatorr'
        }
        if (addFirst) {
          config.config.generators.unshift(addUUID(generator))
        } else {
          config.config.generators.push(addUUID(generator))
        }
      }

      const addSemantic = (semantic, evaluate) => {
        const match = semantic.match || (() => true)
        let apply = semantic
        // if I do apply == semantic.apply or semantic there is one function that has apply defined for some reason even though not explicitly set
        if (semantic.apply && typeof semantic !== 'function') {
          apply = semantic.apply
        }
        const semanticDef = {
          where: semantic.where || bridge.where || helpers.where(4),
          match: (args) => bridge.id == args.context.marker && !!args.context.evaluate == evaluate && match(args),
          apply: (args) => apply(args),
          applyWrapped: semantic,
          property: evaluate ? 'evaluator' : 'semantic'
        }
        if (addFirst) {
          config.config.semantics.unshift(addUUID(semanticDef))
        } else {
          config.config.semantics.push(addUUID(semanticDef))
        }
      }

      if (bridge.evaluator) {
        addSemantic(bridge.evaluator, true)
      }

      if (bridge.semantic) {
        addSemantic(bridge.semantic, false)
      }

      if (bridge.evaluators) {
        const evaluators = [...bridge.evaluators]
        evaluators.reverse()
        if (evaluators) {
          for (const evaluator of evaluators) {
            addSemantic(evaluator, true)
          }
        }
      }

      if (bridge.semantics) {
        const semantics = [...bridge.semantics]
        semantics.reverse()
        if (semantics) {
          for (const semantic of semantics) {
            addSemantic(semantic, false)
          }
        }
      }
    }
  )
}

const handleCalculatedProps = (baseConfig, moreConfig, { addFirst, uuid } = {}) => {
  if (moreConfig.bridges) {
    moreConfig.bridges = moreConfig.bridges.map((bridge) => {
      bridge = { ...bridge }
      const valid = ['after', 'associations', 'before', 'bridge', 'development', 'return_type_selector', 'evaluator', 'evaluators', 'generatorp', 'generatorr', 'generatorpr', 'generators', 'operator', 'id', 'convolution', 'inverted', 'isA', 'children', 'parents',
        'level', 'optional', 'selector', 'semantic', 'semantics', 'words', /Bridge$/, 'localHierarchy', 'levelSpecificHierarchy', 'where', 'uuid']
      helpers.validProps(valid, bridge, 'bridge')
      handleBridgeProps(baseConfig, bridge, { addFirst, uuid })
      return bridge
    })
  }
  if (moreConfig.operators) {
    moreConfig.operators = moreConfig.operators.map((operator) => {
      if (typeof operator === 'string') {
        return { pattern: operator }
      } else {
        return operator
      }
    })
  }
}

if (runtime.process.env.DEBUG_HIERARCHY) {
  global.entodictonDebugHierarchy = JSON.parse(runtime.process.env.DEBUG_HIERARCHY)
}

// i keep randomly doing one of the other so I will just make both work the same way
if (runtime.process.env.DEBUG_PRIORITIES) {
  global.entodictonDebugPriority = JSON.parse(runtime.process.env.DEBUG_PRIORITIES)
}
if (runtime.process.env.DEBUG_PRIORITY) {
  global.entodictonDebugPriority = JSON.parse(runtime.process.env.DEBUG_PRIORITY)
}

if (runtime.process.env.DEBUG_CONTEXTUAL_PRIORITY) {
  global.entodictonDebugContextualPriority = JSON.parse(runtime.process.env.DEBUG_CONTEXTUAL_PRIORITY)
}

if (runtime.process.env.DEBUG_ASSOCIATION) {
  global.entodictonDebugAssociation = JSON.parse(runtime.process.env.DEBUG_ASSOCIATION)
}

if (runtime.process.env.DEBUG_WORD) {
  global.entodictonDebugWord = runtime.process.env.DEBUG_WORD
}

if (runtime.process.env.DEBUG_BRIDGE) {
  // id
  global.entodictonDebugBridge = runtime.process.env.DEBUG_BRIDGE
  global.entodictonDebugBridge[1] = parseInt(global.entodictonDebugBridge[1])
}

if (runtime.process.env.DEBUG_OPERATOR) {
  // id/level
  global.entodictonDebugOperator = runtime.process.env.DEBUG_OPERATOR
}

const hierarchyCanonical = (element) => {
  if (element.child && element.parent) {
    return element
  } else {
    return { child: element[0], parent: element[1] }
  }
}

const isValidWordDef = (word, def, config) => {
  // TODO trie
  /*
  if (!def.id) {
    throw new Error(`In the KM "${config.name}", for the word ${word} the following definition is missing the "id" property: ${JSON.stringify(def)}`)
  }
  */
  /*
  if (!def.initial) {
    throw `In the KM "${config.name}", for the word ${word} the following definition is missing the "initial" property: ${JSON.stringify(def)}`
  }
  */
}

const hierarchyToCanonical = (edge) => {
  if (Array.isArray(edge)) {
    return { child: edge[0], parent: edge[1] }
  }
  return edge
}

const addWord = (config, uuid) => ({ word, id, initial }) => {
  if (!config.words) {
    config.words = {
      literals: {},
      patterns: [],
      hierarchy: []
    }
  }
  const literals = config.words.literals
  const def = { id, initial, uuid }
  if (literals[word]) {
    if (!literals[word].some((e) => helpers.safeEquals(e, def))) {
      literals[word].unshift(def)
    }
  } else {
    literals[word] = [def]
  }
}

const normalizeConfig = (config) => {
  if (config) {
    if (!config.objects) {
      config.objects = { namespaced: {}, }
    }

    for (const bag of bags) {
      if (config[bag]) {
        config[bag] = config[bag].map(normalizeGenerator)
        for (let i = 0; i < config[bag].length; ++i) {
          config[bag][i].index = i
          config[bag][i].km = config.name
        }
      }
    }

    if (config.bridges) {
      for (const bridge of config.bridges) {
        if (!bridge.level) {
          bridge.level = 0
        }
        if (false && !bridge.bridge) {
          bridge.bridge = '{ ...next(operator) }'
        }
      }
    }

    if (config.semantics) {
      for (const semantic of config.semantics) {
        if (semantic.oneShot) {
          semantic.id = semantic.id || helpers.stableId('semantic')
        }
      }
    }

    if (config.operators) {
      for (let i = 0; i < config.operators.length; ++i) {
        if (typeof config.operators[i] === 'string') {
          config.operators[i] = { pattern: config.operators[i] }
        }
      }
    }
  }
}

/*
function isLetter (char) {
  return (/[a-zA-Z]/).test(char)
}
*/

async function configDup (config, options) {
  if (config instanceof Config) {
    return config.copy(options)
  }
  return _.cloneDeep(config)
}

function setWordsUUIDs (words, uuid) {
  const literals = words.literals
  for (const key in literals) {
    literals[key] = literals[key].map((o) => Object.assign(o, { uuid }))
  }
  const patterns = words.patterns
  for (const pattern of patterns) {
    pattern.defs.map((def) => Object.assign(def, { uuid }))
  }
  const hierarchy = words.hierarchy
  for (const pair of hierarchy) {
    pair.uuid = uuid
  }
}

function applyUUID (config, uuid) {
  if (config instanceof Config) {
    config = config.config
  }

  if (config.namespaces) {
    const keys = Object.keys(config.namespaces)
    if (keys.length > 1) {
      debugBreak()
      // throw 'wtf 23'
    }
    if (config.namespaces[keys[0]]) {
      config.namespaces[uuid] = config.namespaces[keys[0]]
    }
  }
  if (config.operators) {
    config.operators = config.operators.map((o) => Object.assign(o, { uuid }))
  }
  if (config.bridges) {
    config.bridges = config.bridges.map((o) => Object.assign(o, { uuid }))
  }
  if (config.generators) {
    config.generators = config.generators.map((o) => Object.assign(o, { uuid }))
  }
  if (config.semantics) {
    config.semantics = config.semantics.map((o) => Object.assign(o, { uuid }))
  }
  if (config.words) {
    setWordsUUIDs(config.words, uuid)
  }
  for (const property of bags) {
    if (config[property]) {
      config[property].forEach((bag) => { bag.uuid = uuid })
    }
  }
}

/*
function namespaceValid (namespace) {
  if (Array.isArray(namespace)) {
    return true
  }
  if (!namespace) {
    return true
  }
  return false
}
*/

class KM {
  toNS (id) {
    if (this._namespace.length === 0) {
      return id
    }
    return `${this._namespace.join('#')}#${id}`
  }

  getName (config) {
    if (config instanceof Config) {
      return config.config.name
    } else {
      return config.name
    }
  }

  get name () {
    return this.toNS(this._name)
  }

  constructor ({ config, getCounter, namespace = [], uuid, isSelf = false }) {
    if (uuid) {
      this._uuid = uuid
      this._class = 'KM'
      this._config = config
      this._namespace = namespace
      this._name = this.getName(config)
      this._isSelf = true // new version the entry is for the containiner class but can't be that due to circularity
    } else {
      // this._uuid = uuidv4();
      if (config instanceof Config) {
        config.valid()
        this._name = config.config.name
        // config.uuid = this._uuid
        this._uuid = config._uuid
      } else {
        // this._uuid = uuidv4()
        this._name = config.name
        this._uuid = getCounter(this._name)
      }
      this._class = 'KM'
      this._config = config
      // applyUUID(this._config, this._uuid)
      if (this._config instanceof Config) {
        this._config.valid()
      }
      this._namespace = namespace
      this._isSelf = false // old version the entry is for the containiner class but can't be that due to circularity
    }
  }

  valid () {
    if (this._config.initializerFn && !(this._config instanceof Config)) {
      debugBreak()
      return false
    }
    if (this._namespace && !Array.isArray(this._namespace)) {
      debugBreak()
      return false
    }
    if (this._config instanceof Config) {
      if (!this._config.valid()) {
        debugBreak()
        return false
      }
    }
    return true
  }

  async copy2 (options) {
    // greg -> add a flag to say don't init the api's
    const config = await configDup(this._config, options)
    const km = new KM({
      config,
      getCounter: options.getCounter,
      name: this._name,
      _uuid: config._uuid,
      namespace: this._namespace,
      isSelf: this._isSelf
    })
    return km // copy2()
  }

  async copy () {
    const km = new KM({
      name: this._name,
      config: await configDup(this._config),
      // _uuid: uuidv4(),
      _uuid: this._config.getCounter(this._config._name),
      getCounter: (name) => this._config.getCounter(name),
      namespace: this._namespace,
      isSelf: this._isSelf
    })
    if (km.config instanceof Config) {
      km.config.valid()
    }
    applyUUID(km._config, km._uuid)
    return km // copy()
  }

  get api () {
    return this._config.api
  }

  toString () {
    return `KM(${this._name}, ${JSON.stringify(this.config)}, ${this._namespace} isSelf(${this._isSelf}))`
  }

  get uuid () {
    return this._uuid
  }

  get config () {
    return this._config
  }

  set config (config) {
    this._config = config
  }

  get isSelf () {
    return this._isSelf
  }

  get namespace () {
    return this._namespace
  }

  set namespace (namespace) {
    this._namespace = namespace
  }
}

const multiApiImpl = (initializer) => {
  return new Object({
    multiApi: true,

    // multi functions
    add: async (config, multiApi, api, apiConstructor) => {
      initializer(config, api)
      const name = api.getName()
      multiApi.apis[name] = api
      multiApi.apiConstructors[name] = apiConstructor
      multiApi.current = name
    },

    initialize: ({ config, api: multiApi }) => {
      for (const apiName in multiApi.apis) {
        const api = multiApi.apis[apiName]
        initializer(config, api)
      }
    },

    // "product1": apiInstance(testData1),
    apis: {
    },

    apiConstructors: {
    },

    // api functions
    api: (multiApi) => multiApi.apis[multiApi.current]
  })
}

class Config {
  toServer (config) {
    return config_toServer(config)
  }

  async fixtures () {
    if (this.testConfig?.fixtures) {
      const args = {}
      args.uuid = this._uuid
      configHelpers.setupArgs(args, this)
      return this.testConfig.fixtures(args)
    }
  }

  getInfo () {
    const name = this.name
    const includes = this.configs.slice(1).map((km) => km.config.name)
    const visibleExamples = []
    for (const test of this.tests) {
      if (!test.developerTest) {
        visibleExamples.push(test.query)
      }
    }
    const templateQueries = []
    if (this.instances && this.instances.length > 0) {
      for (const query of this.instances.slice(-1)[0].configs) {
        if (typeof query === 'string') {
          templateQueries.push(query)
        }
      }
    }
    const info = { name, description: this.description, examples: visibleExamples, template: templateQueries, includes }
    return info
  }

  getPseudoConfig (uuid, config) {
    return {
      description: 'this is a pseudo config that has limited functionality due to being available in the initializer and fixtures function context',
      addAssociation: (...args) => this.addAssociation(...args),
      addAssociations: (...args) => this.addAssociations(...args),
      addBridge: (...args) => this.addBridge(...args, uuid),
      addGenerator: (...args) => this.addGenerator(...args, uuid, config.name),
      addHierarchy: (...args) => this.addHierarchy(...args),
      addOperator: (...args) => this.addOperator(...args, uuid),
      addPriority: (...args) => this.addPriority(...args),
      addPriorities: (...args) => this.addPriorities(...args),
      addSemantic: (...args) => this.addSemantic(...args, uuid, config.name),
      removeSemantic: (...args) => this.removeSemantic(...args, uuid, config.name),
      addWord: (...args) => this.addWord(...args, uuid),
      addPattern: (...args) => this.addPattern(...args, uuid),

      getHierarchy: (...args) => this.config.hierarchy,
      getBridges: (...args) => this.config.bridges,

      addArgs: (...args) => this.addArgs(...args),
      getBridge: (...args) => this.getBridge(...args),
      fragment: (...args) => this.fragment(...args),
      server: (...args) => this.server(...args),
      exists: (...args) => this.exists(...args),
      addAPI: (...args) => this.addAPI(...args)
    }
  }

  inDevelopmentMode (call) {
    config.developmentModeOn += 1
    try {
      call()
    } finally {
      config.developmentModeOn -= 1
    }
  }

  getCounter (maybeName = '') {
    const counter = this.configCounter
    this.configCounter += 1
    return `${maybeName}${counter}`
  }

  setTestConfig (testConfig) {
    this.testConfig = testConfig
  }

  getTestConfig () {
    return this.testConfig
  }

  defaultConfig () {
    this.config = {
      operators: [], // TODO
      bridges: [], // Done
      hierarchy: [], // Done
      name: '',
      namespaces: {
        // "config id" : { namespace: [""], ids: set(ids) }
      },
      eqClasses: [],
      priorities: [], // Done
      version: '3',
      debug: false,
      associations: { // Done
        negative: [],
        positive: []
      },
      objects: {
        // this is where the namespaced configs have their objects
        namespaced: {},
      },
      description: '',
      words: {
        literals: {},
        patterns: [],
        hierarchy: []
      }, // Done
      floaters: [],
      implicits: [],
      flatten: [],
      contexts: [], // TODO future

      expected_generated: [],
      expected_results: [],
      skipSemantics: false
    }
    for (const bag of bags) {
      this.config[bag] = []
    }
    this.configCounter = 1
    // this.wasInitialized = false
  }

  // applies only to config sent to the server

  watching () {
    const props = [
      'operators',
      'bridges',
      'hierarchy',
      'namespaces',
      'eqClasses',
      'priorities',
      'associations',
      'words',
      'floaters',
      'implicits',
      'flatten'
    ]
    const watching = {}
    for (const prop of props) {
      watching[prop] = this.config[prop]
    }
    return JSON.stringify(watching)
  }

  watch () {
    this.watchStart = this.watching()
  }

  wasChanged () {
    if (!this.watchStart) {
      return false
    }
    return this.watchStart !== this.watching()
  }

  exists (marker) {
    for (const bridge of this.config.bridges) {
	    if (bridge.id == marker) {
        return true
      }
    }
  }

  get semantics () {
    return [...this.config.semantics]
  }

  getSemantics (logs = []) {
    return new Semantics(this.config.semantics, logs, { km: this.name })
  }

  getGenerators (logs = []) {
    return new Generators(this.config.generators, logs, { km: this.name })
  }

  warningNotEvaluated (log, value) {
    const description = 'WARNING: for semantics, implement an evaluations handler, set "value" property of the operator to the value.'
    const match = `({context}) => context.marker == '${value.marker}' && context.evaluate && <other conditions as you like>`
    const apply = '({context}) => <do stuff...>; context.value = <value>'
    const input = indent(JSON.stringify(value, null, 2), 2)
    const message = `${description}\nThe semantic would be\n  match: ${match}\n  apply: ${apply}\nThe input context would be:\n${input}\n`
    log.push(indent(message, 4))
  }

  // value is in response field
  // TODO maybe generalize out query+evaluate along the lines of set value and set reference
  async getEvaluator (s, calls, log, context) {
    const instance = await s({ ...context, evaluate: true })
    calls.touch(instance)
    if (!instance.evalue && !instance.verbatim && !instance.value) {
      this.warningNotEvaluated(log, context)
    }
    if (!instance.evalue) {
      instance.evalue = instance.value
      instance.edefault = true
    }
    delete instance.evaluate
    instance.instance = true
    return instance
  }

  fragmentInstantiator (args, contexts) {
    return new Object({
      contexts: () => contexts,
      instantiate: async (mappings) => {
        const instantiated = _.cloneDeep(contexts)
        // const todo = [...instantiated]
        // const todo = [...instantiated]
        const todo = _.clone(instantiated)
        args = { ...args }
        while (todo.length > 0) {
          const context = todo.pop()
          args.context = context
          for (const mapping of mappings) {
            if (await mapping.match(args)) {
              await mapping.apply(args)
            }
          }
          for (const key of Object.keys(context)) {
            // if (['number', 'string', 'boolean'].includes(typeof (context[key]))) {
            if (!helpers.isCompound(context[key])) {
              continue
            }
            if (context[key].instantiated) {
              continue
            }
            todo.push(context[key])
          }
        }
        return instantiated
      }
    })
  }

  fragment (args, query) {
    for (const instance of (this.instances || [])) {
      for (const fragment of (instance.fragments || [])) {
        if (fragment.query === query) {
          return this.fragmentInstantiator(args, fragment.contexts)
        }
      }
      for (const fragment of (instance.resultss || [])) {
        if (fragment.isFragment && fragment.query === query) {
          return this.fragmentInstantiator(args, fragment.contexts)
        }
      }
      for (const fragment of (this.fragmentsBeingBuilt || [])) {
        if (fragment.query === query) {
          return this.fragmentInstantiator(args, fragment.contexts)
        }
      }
    }
  }

  // { rebuild: false, isModule: false }
  needsRebuild (template, instance, options) {
    if (options.rebuild) {
      return true
    }
    const toCanonical = (f) => {
      if (typeof f === 'string') {
        return { query: f }
      } else {
        return f
      }
    }
    const instanceFragments = (instance.fragments || []).map((fragment) => fragment.key || fragment.query).map(toCanonical)
    const templateFragments = (template.fragments || []).concat(this.dynamicFragments).map(toCanonical)
    const hasStop = template.configs && template.configs.find((config) => config.stop)
    // stop means fragments are not build so dont for a rebuild on the diff
    const sameFragments = hasStop || helpers.safeEquals(templateFragments, instanceFragments)
    const toCanonicalQuery = (queryOrConfig) => {
      if (typeof queryOrConfig === 'string') {
        const query = queryOrConfig
        return query
      } else if (typeof queryOrConfig === 'function') {
        if (options.isModule) {
          return { apply: 'function in the browser has webpack rewrites so can not be compared' }
        } else {
          return { apply: queryOrConfig.toString() }
        }
      } else if (queryOrConfig.apply) {
        if (options.isModule) {
          return { apply: 'function in the browser has webpack rewrites so can not be compared' }
        } else {
          return { apply: queryOrConfig.apply }
        }
      } else {
        const config = { ...queryOrConfig }
        delete config.where

        if (config.words && config.words.hierarchy) {
          config.words.hierarchy = config.words.hierarchy.map((value) => {
            value = { ...value }
            delete value.uuid
            return value
          })
        }

        if (config.words && config.words.patterns) {
          config.words.patterns = config.words.patterns.map((value) => {
            value = { ...value }
            value.defs = value.defs.map((value) => {
              value = { ...value }
              delete value.uuid
              return value
            })
            return value
          })
        }

        config.operators = (config.operators || []).map((operator) => {
          if (typeof operator === 'string') {
            return { pattern: operator }
          } else {
            operator = { ...operator }
            delete operator.uuid
            return operator
          }
        })
        config.bridges = (config.bridges || []).map((bridge) => {
          bridge = { ...bridge },
          bridge.level = bridge.level || 0
          delete bridge.uuid
          return bridge
        })
        if (options.isModule) {
          // things like webpack rewrite the functions if there are constants so this compare does not work
          delete config.generators
          delete config.semantics
          config.bridges = (config.bridges || []).map((bridge) => {
            bridge = { ...bridge }
            delete bridge.where
            delete bridge.generatorp
            delete bridge.generatorr
            delete bridge.generatorpr
            delete bridge.evaluator
            delete bridge.evaluators
            delete bridge.semantic
            delete bridge.semantics
            if (false && !bridge.bridge) {
              bridge.bridge = '{ ...next(operator) }'
            }
            return bridge
          })
        } else {
          /* done in updateQueries now
          config.generators = (config.generators || []).map((generator) => {
            generator = { ...generator }
            delete generator.where
            generator.match = generator.match.toString()
            generator.apply = generator.apply.toString()
            return generator
          })
          config.semantics = (config.semantics || []).map((semantic) => {
            semantic = { ...semantic }
            delete semantic.where
            semantic.match = semantic.match.toString()
            semantic.apply = semantic.apply.toString()
            return semantic
          })
          config.bridges = (config.bridges || []).map((bridge) => {
            bridge = { ...bridge }
            delete bridge.where
            if (bridge.generatorp) {
              bridge.generatorp = bridge.generatorp.toString()
            }
            if (bridge.generatorr) {
              bridge.generatorr = bridge.generatorr.toString()
            }
            if (bridge.generatorpr) {
              bridge.generatorpr = bridge.generatorpr.toString()
            }
            if (bridge.evaluator) {
              bridge.evaluator = bridge.evaluator.toString()
            }
            if (bridge.semantic) {
              bridge.semantic = bridge.semantic.toString()
            }
            return bridge
          })
          */
        }
        return config
      }
    }
    const toCanonicalQueries = (elements) => {
      return elements.map(toCanonicalQuery)
    }

    const templateQueries = toCanonicalQueries(template.configs || []).map(helpers.updateQueries)
    const instanceQueries = toCanonicalQueries(instance.configs || [])
    let sameQueries = true
    let startOfChanges
    for (let iq = 0; iq < templateQueries.length; ++iq) {
      if (!helpers.safeEquals(templateQueries[iq], instanceQueries[iq])) {
        // if the current and rest are not queries or fragments then treat as not needing rebuild
        if (templateQueries.length != instanceQueries.length) {
          sameQueries = false
          startOfChanges = iq
        } else {
          let hasQueryOrFragment = false
          for (let rest = iq; rest < templateQueries.length; ++rest) {
            const value = templateQueries[rest]
            if (typeof value === 'string' || (value.query && value.isFragment)) {
              hasQueryOrFragment = true
              break
            }
          }
          if (hasQueryOrFragment) {
            sameQueries = false
            startOfChanges = iq
          }
        }
        break
      }
    }

    const debug = true
    if (debug && startOfChanges) {
      console.log('templateQueries[startOfChanges]', templateQueries[startOfChanges])
      console.log('instanceQueries[startOfChanges]', instanceQueries[startOfChanges])
    }

    // things were deleted case
    if (templateQueries.length < instanceQueries.length) {
      startOfChanges = instanceQueries.length
    }

    if (debug) {
      if (!(instance && sameQueries && sameFragments)) {
        // console.log("instance", instance)
        console.log('sameQueries', sameQueries)
        console.log('sameFragments', sameFragments)
        // console.log("templateFragments", templateFragments)
        // console.log("instanceFragments", instanceFragments)
      }
    }
    if (startOfChanges) {
      return { needsRebuild: true, startOfChanges, previousResultss: instance.resultss }
    } else if (startOfChanges || instance.resultss) {
      return { needsRebuild: !(instance && sameQueries && sameFragments), startOfChanges, previousResultss: instance.resultss }
    } else {
      return { needsRebuild: !(instance && sameQueries && sameFragments) }
    }
  }

  validifyTemplate (template) {
    if (!template.configs && !template.fragments) {
      throw new Error(`Expected the template for ${this.name} to be an object that can have the properties: configs and fragments`)
    }
    for (const query of template.configs || []) {
      if (typeof query === 'string') {
      } else if (query instanceof Config) {
        throw new Error(`For the template for ${this.name}, each element in configs should be either a string or a structure with a config (not a Config object).`)
      }
    }
  }

  toData (data) {
    Object.assign(data, this.config)
    // greg99 delete data.objects
    data.objects = {...this.config.objects}
    if (!this.sendObjectsToServer) {
      delete data.objects.namespaced
    }
    config_toServer(data)
  }

  // loadTemplate
  async load (rebuildTemplate, template, instance, options = { rebuild: false, previousResultss: undefined, startOfChanges: undefined }) {
    this.validifyTemplate(template)
    instance.template = template
    this.logs.push(`loading template for ${this.name}`)
    if (options.rebuild) {
      // TODO fix beforeQuery
      template = { fragments: [], configs: [], ...template }
      template.fragments = template.fragments.concat(this.dynamicFragments)
      await rebuildTemplate({ config: this, instance, target: this.name, startOfChanges: options.startOfChanges, beforeQuery: () => {}, template, ...options, previousResultss: options.previousResultss || instance.resultss })
    } else {
      // no change
      // this.initInstances.push({ ...instance, name: config.name })
      const isEmpty = (instance) => {
        const properties = [
          'configs',
          'resultss',
          'fragments',
          'semantics',
          'associations'
        ]
        return !properties.find((property) => instance[property] && instance[property].length > 0)
      }
      if (!isEmpty(instance)) {
        // fix up apply functions
        for (let i = 0; i < instance.resultss.length; ++i) {
          const result = instance.resultss[i]
          if (result.apply) {
            result.apply = template.configs[i]
          }
        }
        instance.name = this.name
        this.initInstances.push(instance)
        this.instances.push(instance)
        await configHelpers.loadInstance(this, instance)
      }
      this.expect_template = false
    }
  }

  watchNewFragments (list) {
    this.addFragmentWatcher = list
  }

  addFragments (fragments) {
    // only run this if not loading as module write error if loading as module and different
    this.dynamicFragments = this.dynamicFragments.concat(fragments)
    if (this.addFragmentWatcher) {
      for (const fragment of fragments) {
        this.addFragmentWatcher.push(fragment)
      }
    }
  }

  objects () {
    return this.config.objects.namespaced[this._uuid]
  }

  addAssociations (associations) {
    for (const association of associations) {
      this.addAssociation(association)
    }
  }

  debugConfig () {
  }

  addAssociation (association) {
    if (!this.config.associations) {
      this.config.associations = {
        negative: [],
        positive: []
      }
    }
    debugAssociation(association)
    this.config.associations.positive.push(association)
    this._delta.json.associations.push({ action: 'add', association })
  }

  // TODO add more error checking to these like addHierarchy has
  // TODO change name from priorities to priority
  // [ context: <list of [id, level]>, choose: [<indexes of prioritized operator>], [ordered: [true|false]] ]
  addPriority (priority) {
    if (!this.config.priorities) {
      this.config.priorities = []
    }
    debugPriority(priority)
    priority_valid(priority)
    this.config.priorities.push(priority)
    this._delta.json.priorities.push({ action: 'add', priority })
  }

  addPriorities (priorities) {
    for (const priority of priorities) {
      this.addPriority(priority)
    }
  }

  addHierarchy (child, parent, instance) {
    if (child && parent || !child || Array.isArray(child) || (typeof child === 'string' && !parent)) {
      this.addHierarchyChildParent(child, parent, instance)
      // this.addHierarchyProperties ({ child, parent })
    } else {
      this.addHierarchyProperties(child)
    }
  }

  addHierarchyInternal (edge) {
    debugHierarchy([edge[0], edge[1]])
    // because this is called from the semantics and internally. in the semantics the config can be a pseudo config
    // where hierarchy and config.hierarchy do not match
    if (this.hierarchy) {
      this.hierarchy.addEdge(edge)
      // no dups due to sharing
      if (this.hierarchy._edges != this.config.hierarchy) {
        this.config.hierarchy.push(edge)
        this._delta.json.hierarchy.push(edge)
      }
    } else {
      this.config.hierarchy.push(edge)
      this._delta.json.hierarchy.push(edge)
    }
  }

  addHierarchyProperties (properties) {
    const { child, parent, instance } = properties
    if (typeof child !== 'string') {
      throw new Error(`addHierarchy expected child property to be a string. got ${JSON.stringify(child)}`)
    }
    if (typeof parent !== 'string') {
      throw new Error(`addHierarchy expected parent property to be a string. got ${JSON.stringify(parent)}`)
    }
    if (instance && typeof instance !== 'boolean') {
      throw new Error(`addHierarchy expected instance property to be a boolean or undefined. got ${JSON.stringify(instance)}`)
    }
    const edge = [child, parent, instance || false]
    this.addHierarchyInternal(edge)
  }

  addHierarchyChildParent (child, parent, instance) {
    if (typeof child !== 'string') {
      throw new Error(`addHierarchy expected child to be a string. got ${JSON.stringify(child)}`)
    }
    if (typeof parent !== 'string') {
      throw new Error(`addHierarchy expected parent to be a string. got ${JSON.stringify(parent)}`)
    }
    if (instance && typeof instance !== 'boolean') {
      throw new Error(`addHierarchy expected instance property to be a boolean or undefined. got ${JSON.stringify(instance)}`)
    }
    debugHierarchy([child, parent])
    if (this.config.hierarchy.find((element) => {
      const hc = hierarchyCanonical(element)
      if (child == hc.child && parent == hc.parent) {
        return true
      }
    })) {
      return
    }

    const edge = [child, parent, instance || false]
    this.addHierarchyInternal(edge)
  }

  getBridge (id, level) {
    if (level) {
      return this.config.bridges.find((bridge) => bridge.id == id && bridge.level == level)
    } else {
      return this.config.bridges.find((bridge) => bridge.id == id)
    }
  }

  addBridge (bridge, uuid) {
    if (!this.config.bridges) {
      this.config.bridges = []
    }
    const bridges = this.config.bridges
    const def = Object.assign({}, bridge, { uuid: uuid || this._uuid })

    debugBridge(bridge)
    if (bridge.allowDups) {
      // if (bridges.find( (b) => b.id == bridge.id && b.level == bridge.level && b.bridge == bridge.bridge )) {
      if (bridges.find((b) => b.id == bridge.id && b.level == bridge.level)) {
        return
      }
    }
    if (global.transitoryMode) {
      def.transitoryMode = true
    }
    handleBridgeProps(this, def, { uuid })
    bridges.push(def)
    this.checkBridges()
    this._delta.json.bridges.push({ action: 'add', bridge: def })
  }

  addGenerator (generator, uuid, name) {
    if (!(typeof generator.match === 'function')) {
      throw new Error('addGenerator: Expected matcher to be a function')
    }
    if (!(typeof generator.apply === 'function')) {
      throw new Error('addGenerator: Expected action to be a function')
    }

    if (!this.config.generators) {
      this.config.generators = []
    }

    if (!generator.where) {
      generator.where = helpers.where(3)
    }

    const generators = this.config.generators
    Object.assign(generator, { uuid: uuid || this._uuid, km: name || this.name, index: generators.length })
    // used to be unshift
    generators.unshift(generator)
  }

  addSemantic (semantic, uuid, name) {
    if (!(typeof semantic.match === 'function')) {
      throw new Error('addSemantic: Expected match to be a function')
    }

    if (!(typeof semantic.apply === 'function')) {
      throw new Error('addSemantic: Expected apply to be a function')
    }

    if (!this.config.semantics) {
      this.config.semantics = []
    }

    if (!semantic.where) {
      semantic.where = helpers.where(3)
    }

    const semantics = this.config.semantics
    Object.assign(semantic, { uuid: uuid || semantic.uuid || this._uuid, km: name || this.name, index: semantics.length, id: semantic.id || uuidv4() })
    semantics.unshift(semantic)
  }

  removeSemantic (deleteSemantic) {
    const id = deleteSemantic.id || deleteSemantic
    const todo = [id]
    const seen = new Set()

    while (todo.length > 0) {
      const id = todo.pop()
      if (seen.has(id)) {
        continue
      }
      seen.add(id)
      const index = this.config.semantics.findIndex((semantic) => semantic.id === id)
      if (index == -1) {
        continue
      }
      for (const tied_id of this.config.semantics[index].tied_ids || []) {
        if (!seen.has(tied_id)) {
          todo.push(tied_id)
        }
      }
      if (index >= 0) {
        this.config.semantics.splice(index, 1)
      }
    }
  }

  addOperator (objectOrPattern, uuid) {
    if (!this.config.operators) {
      this.config.operators = []
    }

    const operators = this.config.operators

    let operator
    if (typeof objectOrPattern === 'string') {
      operator = { pattern: objectOrPattern, uuid: uuid || this._uuid }
    } else {
      operator = Object.assign({}, objectOrPattern, { uuid: uuid || this._uuid })
    }

    debugOperator(operator)

    if (operator.allowDups) {
      if (operators.find((o) => o.pattern == operator.pattern)) {
        return
      }
    }

    operators.unshift(operator)
    this.checkOperators()

    this._delta.json.operators.push({ action: 'add', operator })
  }

  addWord (word, def, uuid) {
    this.addWordInternal(word, def, uuid)
  }

  addWordInternal (word, def, uuid) {
    if (!this.config.words) {
      this.config.words = {
        literals: {},
        patterns: [],
        hierarchy: []
      }
    }
    debugWord(word)

    const literals = this.config.words.literals
    def = Object.assign({}, def, { uuid: uuid || this._uuid })
    if (literals[word]) {
      if (!literals[word].some((e) => helpers.safeEquals(e, def))) {
        literals[word].unshift(def)
      }
    } else {
      literals[word] = [def]
    }

    this._delta.json.words.push({ action: 'add', word, def })
  }

  addPattern (pattern, def, uuid) {
    if (!this.config.words) {
      this.config.words = {
        literals: {},
        patterns: [],
        hierarchy: []
      }
    }

    const patterns = this.config.words.patterns
    def = Object.assign({}, def, { uuid: uuid || this._uuid })
    patterns.unshift({ pattern, defs: [def] })
    this._delta.json.words.push({ action: 'add', pattern, defs: [def] })
  }

  getAPI (uuid) {
    if (this._uuid === uuid) {
      return this.api
    }
    for (const km of this.configs) {
      if (km._uuid === uuid) {
        return km.config.api
      }
    }
  }

  getAPIs (uuid) {
    let config
    if (this._uuid === uuid) {
      config = this
    } else {
      for (const km of this.configs) {
        if (km._uuid === uuid) {
          config = km.config
          break
        }
      }
    }
    if (config && config._api && config._api.multiApi) {
      return config._api.apis
    }
  }

  getServer () {
    return this._server
  }

  getAPIKey () {
    return this._key
  }

  getQueryParams () {
    return this._queryParams
  }

  setQueryParams (queryParams) {
    this._queryParams = queryParams
  }

  server (server, apiKey, queryParams) {
    if (server) {
      this._server = server
    }
    if (apiKey) {
      this._key = apiKey
    }
    this._queryParams = queryParams

    if (this._api && this._api.multiApi) {
      for (const key of Object.keys(this._api.apis)) {
        const api = this._api.apis[key]
        if (api.server) {
          api.server(server, apiKey)
        } else {
          api.credentials = { server, key: apiKey }
        }
      }
    }

    for (const km of (this.configs || [])) {
      const config = km._config
      if (config.server) {
        km._config.server(server, apiKey)
      }
    }
  }

  getParams () {
    const params = {
      objects: this.config.objects,
      config: this
    }
    for (const bag of bags) {
      params[bag] = this.config[bag]
    }
    return params
  }

  async processContext (context) {
    return await configHelpers.processContext(context, this.getParams())
  }

  process (query, options) {
    return this.clientProcess(this, query, options)
  }

  query (query, options) {
    return this.process(query, options)
  }

  processQuery (query, options) {
    return this.process(query, options)
  }

  initDefaults () {
    const init = (config) => {
      if (!config.objects) {
        config.objects = {
          namespaced: {
          },
        }
      }

      if (!config.associations) {
        config.associations = {}
      }

      if (!config.associations.positive) {
        config.associations.positive = []
      }

      if (!config.associations.negative) {
        config.associations.negative = []
      }
    }
    init(this.config)
    init(this.initConfig)
  }

  km (name) {
    return this.getConfig(name)
  }

  // set the args in the api's
  setArgs (args) {
    const setArgs = (config) => {
      if (!config._api) {
        return
      }
      if (config._api.multiApi) {
        for (const api in config._api.multiApi) {
          config._api.multiApi[api].args = args
        }
      } else {
        config._api.args = { ...args, ...args.getUUIDScoped(config.uuid) }
      }
    }

    setArgs(this)
    for (const config of this.configs) {
      if (config.config instanceof Config) {
        setArgs(config.config)
      }
    }
  }

  getConfigs () {
    const configs = {}
    configs[this.name] = this
    for (const config of this.configs) {
      if (config.config instanceof Config) {
        configs[config.config.name] = config.config
      }
    }
    return configs
  }

  getConfigByUUID (uuid) {
    if (this.uuid === uuid) {
      return this
    }
    for (const config of this.configs) {
      if (config.config instanceof Config) {
        if (config.uuid === uuid) {
          return config.config
        }
      }
    }
  }

  getConfig (name) {
    if (this.name === name) {
      return this
    }
    for (const config of this.configs) {
      if (config.config instanceof Config) {
        if (config.config.nsToString(config.config.name) === name) {
          return config.config
        }
      }
    }
  }

  get kms () {
    const kms = {}
    kms[this.name] = this
    for (const config of this.configs) {
      if (config.config instanceof Config) {
        kms[config.config.name] = config.config
      }
    }
    return kms
  }

  removeDevelopmentElements (config) {
    if (!config) {
      return
    }
    config.operators = config.operators.filter((element) => !element.development)
    config.bridges = config.bridges.filter((element) => !element.development)
    config.generators = config.generators.filter((element) => !element.development)
    config.semantics = config.semantics.filter((element) => !element.development)
    config.hierarchy = (config.hierarchy).filter((element) => !element.development)

    const literals = config.words.literals
    for (const word in literals) {
      const defs = literals[word] || []
      literals[word] = defs.filter((def) => !def.development)
      if (literals[word].length == 0) {
        delete literals[word]
      }
    }

    const patterns = config.words.patterns || []
    const patternsPrime = []
    for (const pattern of patterns) {
      let defs = pattern.defs || []
      defs = defs.filter((def) => !def.development)
      if (defs.length !== 0) {
        patternsPrime.push({ ...pattern, defs })
      }
    }
    config.words.patterns = patternsPrime

    const hierarchy = config.words.hierarchy || []
    const hierarchyPrime = []
    for (const pair of hierarchy) {
      if (!pair.development) {
        hierarchyPrime.push(pair)
      }
    }
    config.words.hierarchy = hierarchyPrime
  }

  terminate () {
    this.configs.forEach((km) => {
      const config = km.config
      if (!config.terminatorFn) {
        this.terminatorFn(this)
      } else {
        config.terminatorFn(this)
      }
    })
  }

  setTerminator (terminatorFn) {
    if (terminatorFn) {
      this.terminatorFn = terminatorFn
    }
  }

  // configs = [ { config, namespace } ... ]
  constructor (config, module, clientProcess, apiKMs) {
    if (config instanceof Config) {
      throw new Error('Excepted the config argument to be a hash not a Config object')
    }

    if (!apiKMs) {
      apiKMs = []
    }

    if (config) {
      validConfigProps(config)

      config.operators = config.operators || []
      config.bridges = config.bridges || []
      config.words = config.words || { literals: {}, patterns: [], hierarchy: [] }
      config.generators = config.generators || []
      config.semantics = config.semantics || []
      config.hierarchy = config.hierarchy || []
      config.associations = config.associations || { negative: [], positive: [] }
      config.priorities = config.priorities || []
    }

    this._apiKMs = apiKMs

    this.clientProcess = clientProcess
    this.maxDepth = 20 // for generators and semantics
    this.debugLoops = false // for generators and semantics

    this.allowDelta = false
    this.resetDelta()

    this.addedArgss = []
    let isProcess = require.main === module
    if (global.theprogrammablemind && config) {
      if (global.theprogrammablemind.loadForTesting[config.name]) {
        isProcess = true
        this.loadedForTesting = true
      }
    }
    this.isModule = !isProcess
    if (this.isModule) {
      this.removeDevelopmentElements(config)
    }
    this.initInstances = []
    this.instances = []
    this.logs = []
    this.dynamicFragments = []
    // when running configs any bridges added are marked as transitory so that the associated will ignore those op's
    this.transitoryMode = false

    if (config && config.words) {
      initWords(config.words)
      isValidWordDef(config.words)
    }

    if (config && config.priorities) {
      priorities_valid(config.priorities)
    }

    normalizeConfig(config)

    // set the default server so stuff just works
    // this.server('https://184.67.27.82:3000', '6804954f-e56d-471f-bbb8-08e3c54d9321')
    this.server('https://thinktelligence.com:3000', '6804954f-e56d-471f-bbb8-08e3c54d9321')

    this.defaultConfig()
    this.initializerFn = ({ currentConfig }) => {
      if (currentConfig instanceof Config) {
        currentConfig.wasInitialized = true
      }
    }
    this.terminatorFn = () => {}
    if (config) {
      this.name = config.name
    }
    this.loadOrder = new DigraphInternal()
    this.wasInitialized = false
    this.configs = []
    this._api = undefined
    this.sendObjectsToServer = false
    this._namespace = []
    this._eqClasses = []
    // this._uuid = uuidv4()
    this._uuid = this.getCounter(this.name)
    if (config) {
      config = _.cloneDeep(config)
      this.config = config
      handleCalculatedProps(this, config)
    }
    this.hierarchy = new DigraphInternal(this.config.hierarchy)
    this.initConfig = _.cloneDeep(this.config)
    this.configs.push(new KM({ config: this.config, getCounter: (name) => this.config.getCounter(name), uuid: this._uuid }))

    this.setUUIDs()
    this.initDefaults()
    if (!this.config.objects.namespaced) {
      this.config.objects.namespaced = {}
    }
    this.get('objects').namespaced[this._uuid] = {}
    this.valid()
    this.checks()
    debugConfigProps(this.config)
  }

  setSendObjectsToServer() {
    this.sendObjectsToServer = true
  }

  addArgs (moreArgs) {
    this.addedArgss.push(moreArgs)
  }

  stop_auto_rebuild () {
    this._stop_auto_rebuild = true
  }

  async restart_auto_rebuild () {
    this._stop_auto_rebuild = false
    await this.rebuild()
  }

  getAddedArgs (args) {
    for (let addedArgs of this.addedArgss) {
      addedArgs = addedArgs(args)
      const getUUIDScoped = addedArgs.getUUIDScoped
      delete addedArgs.getUUIDScoped
      Object.assign(args, addedArgs)
      if (getUUIDScoped) {
        const currentGetUUIDScoped = args.getUUIDScoped
        args.getUUIDScoped = (uuid) => Object.assign(currentGetUUIDScoped(uuid), getUUIDScoped(uuid))
      }
    }
  }

  async setMultiApi (initializer) {
    await this.setApi(() => multiApiImpl(initializer))
  }

  get multiApi () {
    if (this._api.multiApi) {
      return this._api
    } else {
      return null
    }
  }

  hasDelta () {
    return this._delta.json
  }

  delta () {
    return {
      cacheKey: this._delta.cacheKey,
      json: this._delta.json
    }
  }

  resetDelta (cacheKey) {
    this._delta = {
      cacheKey,
      json: {
        words: [],
        operators: [],
        bridges: [],
        associations: [],
        priorities: [],
        hierarchy: []
      }
    }
  }

  set cacheKey (cacheKey) {
    this.resetDelta(cacheKey)
  }

  // use this to set the api if you only want to partially override the KM api
  apiBase (name) {
    if (this._api && this._api.multiApi) {
      throw new Error('This is intended to be used to instantiate a new class based on the existing API.')
    } else {
      if (name) {
        if (this.name == name) {
          return this._api.constructor
        } else {
          return this.getConfig(name)._api.constructor
        }
      } else {
        return this._api.constructor
      }
    }
  }

  get api () {
    if (this._stop_auto_rebuild) {
      throw new Error('The API cannot be accessed until the auto rebuild is restarted')
    }

    if (this._api && this._api.multiApi) {
      return this._api.api(this._api)
    } else {
      return this._api
    }
  }

  set api (api) {
    this._api = api
  }

  async addAPI (api) {
    // console.trace()
    // throw "addAPI"
    if (this._api && this._api.multiApi) {
      await this._api.add(this, this._api, api)
    } else {
      throw new Error('Can only add apis to a multi-api')
    }
  }

  // constructors is a constructor
  async setApi (constructor) {
    if (typeof constructor !== 'function') {
      throw new Error(`Expected the argument to be an API constructor for ${this.name}.`)
    }
    const value = constructor()
    if (this._apiKMs.length > 0) {
      for (const name of this._apiKMs) {
        const api = value[name]
        if (!api) {
          throw new Error(`The API for ${this.name} is not being provided by the API constructor.`)
        }
        if (!api.initialize) {
          throw new Error(`Expected the API for ${this.name} to have an initialize function.`)
        }
      }
    } else {
      if (!value.initialize) {
        throw new Error(`Expected the API to have an initialize function for ${this.name}.`)
      }
    }

    if (this._api && this._api.multiApi) {
      await this._api.add(this, this._api, value, constructor)
      const previousApiConstructor = this._apiConstructor
      this._apiConstructor = (config) => {
        const api = previousApiConstructor(config)
        // does this need await?
        api.add(config, api, constructor(config), constructor)
        return api
      }
    } else {
      this._apiConstructor = constructor
      if (this._apiKMs.length > 0) {
        for (const name of this._apiKMs) {
          this.km(name)._api = value[name]
        }
      } else {
        this._api = value
      }
      await this.rebuild()
    }
  }

  set afterTest (value) {
    this._afterTest = value
  }

  get uuid () {
    return this._uuid
  }

  set uuid (uuid) {
    const map = { [this._uuid]: uuid }
    this._uuid = uuid
    this.configCounter += 1
    this.mapUUIDs(map)
  }

  // remove all added modules and initialize with the init config
  async resetToOne () {
    /*
    this.config = _.cloneDeep(this.initConfig)
    this.configs = [this.configs[0]]
    this.setUUIDs()
    this.initDefaults()
    */
    this.configs = [this.configs[0]]
    this.defaultConfig()
    Object.assign(this.config.objects, _.cloneDeep(this.initConfig.objects || {}))
    await this.initializeConfigFromConfigs({ others: [], objects: this.config.objects.namespaced, moreNames: [], callInitializers: false })
    const map = {}
    for (let i = 0; i < this.configs.length; ++i) {
      map[this.configs[i].uuid] = this.configs[i].uuid
    }
    this.mapUUIDs(map)
    // this.valid() init was not run because the kms are not all setup yet
  }

  // TODO add more details
  equal (config) {
    if (JSON.stringify(this.config) != JSON.stringify(config.config)) {
      return false
    }
    return true
  }

  dump (fn) {
    runtime.fs.writeFileSync(fn, JSON.stringify(this.config, 0, 2))
  }

  async copy (options = { callInitializers: true }) {
    this.valid()
    const cp = new Config()
    cp.logs = []
    cp.maxDepth = this.maxDepth
    cp.debugLoops = this.debugLoops
    cp.transitoryMode = this.transitoryMode
    // cp.configs = this.configs.map((km) => await km.copy2(Object.assign({}, options, { getCounter: (name) => cp.getCounter(name), callInitializers: false })))
    cp.configs = []
    for (const km of this.configs) {
      cp.configs.push(await km.copy2(Object.assign({}, options, { getCounter: (name) => cp.getCounter(name), callInitializers: false })))
    }
    cp._uuid = cp.configs[0]._uuid
    // update uuid here set the uuid in the objects and add error checking
    cp.initializerFn = this.initializerFn
    cp.terminatorFn = this.terminatorFn
    cp._apiKMs = this._apiKMs
    cp._apiConstructor = this._apiConstructor
    if (cp._apiConstructor) {
      if (this._apiKMs.length > 0) {
        const apis = cp._apiConstructor(cp)
        for (const name of this._apiKMs) {
          if (name == this.name) {
            cp._api = apis[name]
          } else {
            cp.km(name)._api = apis[name]
          }
        }
      } else {
        cp._api = cp._apiConstructor(cp)
      }
    }
    cp._namespace = this._namespace
    cp._eqClasses = this._eqClasses
    cp.name = this.name
    cp.description = this.description
    cp.tests = this.tests
    cp.isModule = this.isModule
    cp.loadedForTesting = this.loadedForTesting
    cp.initInstances = this.initInstances.slice()
    cp.instances = this.instances.slice()
    cp.configCounter = this.configCounter
    cp.testConfig = this.testConfig
    cp._server = this._server
    cp.hierarchy = new DigraphInternal(this.config.hierarchy)
    cp.sendObjectsToServer = this.sendObjectsToServer

    cp.initConfig = _.cloneDeep(this.initConfig)
    cp.defaultConfig()
    // cp.wasInitialized = false;  // since default config GREG
    cp.resetWasInitialized()
    Object.assign(cp.config.objects, _.cloneDeep(this.initConfig.objects || {}))
    await cp.initializeConfigFromConfigs(Object.assign({ others: [], objects: cp.config.objects.namespaced, moreNames: [] }, options))
    const map = {}
    for (let i = 0; i < this.configs.length; ++i) {
      map[this.configs[i].uuid] = cp.configs[i].uuid
    }
    cp.mapUUIDs(map)

    if (options.callInitializers) {
      await cp.rebuild(options) // in copy
    } else {
      if (!cp.config.objects) {
        cp.config.objects = { 
          namespaced: {},
        }
      } else if (!cp.config.objects.namespaced) {
        cp.config.objects.namespaced = {}
      }
      cp.configs.forEach((km) => {
        cp.config.objects.namespaced[km._uuid] = {}
      })
    }
    cp.valid()
    return cp
  }

  setUUIDs () {
    this.config.bridges && this.config.bridges.forEach((bridge) => { bridge.uuid = this._uuid })
    this.config.words && setWordsUUIDs(this.config.words, this._uuid)
    this.config.operators && this.config.operators.forEach((operator) => { operator.uuid = this._uuid })
    const ids = Array.from(new Set(this.config.bridges.map((bridge) => bridge.id)))
    ids.sort()
    this.config.namespaces = {}
    // if (true || ids.length > 0) {
    this.config.namespaces[this.uuid] = { ids, namespace: this._namespace }
    for (const bag of bags) {
      if (this.config[bag]) {
        this.config[bag].forEach((bag) => { bag.uuid = this._uuid })
      }
    }
  }

  mapUUIDs (map) {
    if (this._eqClasses) {
      this._eqClasses = this._eqClasses.map((eqclass) => eqclass.map((uuid) => map[uuid] || uuid))
    }

    if (this.config.namespaces) {
      const ns = {}
      for (const uuid of Object.keys(this.config.namespaces)) {
        const uuidPrime = map[uuid] || uuid
        ns[uuidPrime] = this.config.namespaces[uuid]
      }
      this.config.namespaces = ns
    }

    if (!this.config.words) {
      this.config.words = {}
    }

    if (this.config.words.literals) {
      const literals = this.config.words.literals
      for (const key in literals) {
        literals[key].forEach((o) => {
          if (o.uuid) {
            if (map[o.uuid]) {
              o.uuid = map[o.uuid]
            }
          } else {
            o.uuid = this._uuid
          }
        })
      }
    }

    const mapDefList = (list) => {
      for (const element of list) {
        element.defs.forEach((o) => {
          if (o.uuid) {
            if (map[o.uuid]) {
              o.uuid = map[o.uuid]
            }
          } else {
            o.uuid = this._uuid
          }
        })
      }
    }

    if (this.config.words.patterns) {
      mapDefList(this.config.words.patterns)
    }

    if (this.config.words.hierarchy) {
      for (const o of this.config.words.hierarchy) {
        if (o.uuid) {
          if (map[o.uuid]) {
            o.uuid = map[o.uuid]
          }
        } else {
          o.uuid = this._uuid
        }
      }
    }

    if (this.config.bridges) {
      this.config.bridges.forEach((bridge) => {
        if (bridge.uuid) {
          if (map[bridge.uuid]) {
            bridge.uuid = map[bridge.uuid]
          }
        } else {
          bridge.uuid = this._uuid
        }
      })
    }

    if (this.config.operators) {
      this.config.operators.forEach((operator) => {
        if (operator.uuid) {
          if (map[operator.uuid]) {
            operator.uuid = map[operator.uuid]
          }
        } else {
          operator.uuid = this._uuid
        }
      })
    }

    for (const bag of bags) {
      if (this.config[bag]) {
        this.config[bag].forEach((bag) => {
          if (bag.uuid) {
            if (map[bag.uuid]) {
              bag.uuid = map[bag.uuid]
            }
          } else {
            bag.uuid = this._uuid
          }
        })
      }
    }
  }

  initialize23 ({ force = true } = {}) {
    if (force || !this.wasInitialized) {
      const objects = this.config.objects.namespaced[this._uuid]
      this.initializerFn(setupInitializerFNArgs(this, { testConfig: this, currentConfig: this, objects, uuid: this._uuid, namespace: '' }))
      this.wasInitialized = true
    }
  }

  async initializer (fn, options = {}) {
    if (options) {
      for (const option of Object.keys(options)) {
        const validOptions = []
        if (!validOptions.includes(option)) {
          throw new Error(`For Config.initializer, unrecognized option ${option}. The valid options are ${validOptions}`)
        }
      }
    }
    this.wasInitialized = false
    this.initializerFn = (args, { dontCallFn } = {}) => {
      const transitoryMode = global.transitoryMode
      global.transitoryMode = false
      // const baseConfig = args.baseConfig
      const currentConfig = args.currentConfig

      if (args.isAfterApi) {
        fn(args)
      }
      currentConfig.wasInitialized = true
      global.transitoryMode = transitoryMode
    }
    await this.rebuild()
  }

  nsToString (id) {
    return `${this._namespace.concat(id).join('#')}`
  }

  validBag (bag) {
    if (bag.match === null) {
      return false
    }
    if (bag.apply === null) {
      return false
    }
    if (bag.uuid === null) {
      return false
    }
    return true
  }

  valid () {
    const uuids = this.configs.map((config) => config._uuid)

    if (!this.logs) {
      debugBreak()
      return false
    }
    for (const bag of bags) {
      if (this.config[bag]) {
        const problem = this.config[bag].some((bag) => {
          if (!this.validBag(bag)) {
            debugBreak()
            return true
          }
          if (!uuids.includes(bag.uuid)) {
            debugBreak()
            return true
          }
          return false
        })

        if (problem) {
          return false
        }
      }
    }

    if (this._uuid !== this.configs[0].uuid) {
      debugBreak()
      return false
    }
    if (this.configs[0]._config instanceof Config) {
      debugBreak()
      return false
    }

    if (!this.config.objects) {
      debugBreak()
      return false
    }

    /* TODO greg11
    if (!this.hierarchy) {
      debugBreak()
      return false
    }
    */

    const literals = this.config.words.literals
    if (literals) {
      for (const key in literals) {
        const values = literals[key]
        if (values.some((word) => (Object.keys(word).includes('uuid') && !word.uuid))) {
          debugBreak()
          return false
        }
      }
    }

    const kmsUuids = this.configs.map((km) => km.uuid)
    const bridgesUuids = this.config.bridges.map((bridge) => bridge.uuid).filter((uuid) => uuid)
    let result = true
    bridgesUuids.forEach((buuid) => {
      if (!kmsUuids.includes(buuid)) {
        debugBreak()
        result = false
      }
    })

    if (this.get('namespaces')) {
      const namespaceUuids = Object.keys(this.get('namespaces'))
      namespaceUuids.forEach((uuid) => {
        if (!kmsUuids.includes(uuid)) {
          debugBreak() // in namespaces
          result = false
        }
      })
      if (!result) {
        debugBreak()
        return false
      }
      kmsUuids.forEach((uuid) => {
        if (!namespaceUuids.includes(uuid)) {
          debugBreak() // in namespaces
          result = false
        }
      })
      if (!result) {
        debugBreak()
        return false
      }
    }

    if (Object.keys(this.config.namespaces || {}) === ['undefined']) {
      debugBreak()
      result = false
    }
    if (!result) {
      debugBreak() // not valid
      return false
    }

    result = true
    this.configs.forEach((km) => {
      if (!km.valid()) {
        result = false
      }
    })
    if (!result) {
      debugBreak() // not valid
      return false
    }
    return result
  }

  resetWasInitialized () {
    this.wasInitialized = false
    this.configs.forEach((km) => {
      const config = km.config
      if (config instanceof Config) {
        config.wasInitialized = false
      }
    })
  }

  // rebuild ({ isModule: mainIsModule = false } = {}) {
  async rebuild ({ isModule: mainIsModule } = {}) {
    if (this._stop_auto_rebuild) {
      return
    }
    this.resetDelta()
    const debug = this.config.debug
    this.config = _.cloneDeep(this.initConfig)
    this.hierarchy = new DigraphInternal(this.config.hierarchy)
    if (debug) {
      this.config.debug = debug
    }
    // already set
    // this.isModule = this.isModule || mainIsModule
    mainIsModule = (mainIsModule === undefined) ? this.isModule : mainIsModule
    if (mainIsModule !== undefined) {
      this.isModule = mainIsModule
    }
    if (this.loadedForTesting) {
      this.isModule = false
    }
    this.config.objects.namespaced = {}
    this.resetWasInitialized()

    // reorder configs base on load ordering
    {
      const ordering = this.loadOrder.order(this.configs.map((km) => km.name || km.uuid))
      const oconfigs = []
      for (const nameOrUUID of ordering) {
        for (const km of this.configs) {
          if (km.name === nameOrUUID || km.uuid === nameOrUUID) {
            oconfigs.push(km)
          }
        }
      }
      this.configs = [...oconfigs]
    }

    const addInternals = []
    const inits = []
    const initAfterApis = []
    this.configs.forEach((km) => {
      const namespace = km.namespace
      this.config.objects.namespaced[km._uuid] = {
        km: km._uuid
      }
      const namespacedObjects = this.config.objects.namespaced[km._uuid]
      this.setupNamespace(km)
      // const aw = (word, def) => this.addWord(word, def)
      // const ag = (matchOrGenerator, applyOrNothing) => this.addGenerator(matchOrGenerator, applyOrNothing)
      let config = km.config

      if (config.addedArgss) {
        this.addedArgss = this.addedArgss.concat(config.addedArgss)
      }

      let isSelf = false
      let isModule = true
      if (!(config instanceof Config)) {
        config = this
        isSelf = true
        isModule = config.isModule || mainIsModule
      } else {
        isModule = config.isModule
      }
      if (!isSelf) {
        config.config = _.cloneDeep(config.initConfig)
        config.hierarchy = new DigraphInternal(config.config.hierarchy)
      }
      config.wasInitialized = false
      // TODO change name of config: to baseConfig:
      const kmFn = (name) => {
        const config = this.getConfig(name)
        return config
      }
      // const hierarchy = new DigraphInternal((config.config || {}).hierarchy)
      const args = new Object(setupInitializerFNArgs(this, {
        isModule,
        hierarchy: this.hierarchy,
        testConfig: config,
        currentConfig: config,
        uuid: config._uuid,
        objects: namespacedObjects,
        globals: this.config.objects,
        namespace,
        api: config.api
      }))

      const currentConfig = args.currentConfig

      /*
      if (args.currentConfig.api) {
        // args.currentConfig.api.objects = args.objects
        // TODO assign pseudo config?
        // args.currentConfig.api.config = () => args.baseConfig
        // args.currentConfig.api.uuid = args.currentConfig._uuid
        args.currentConfig.wasInitialized = true
      }
      */
      config.initializerFn(args, { dontCallFn: true })
      initAfterApis.unshift({ config, args })
      if (config._api) {
        if (config._api.initialize) {
          // reverse the list
          // TODO sync up the args with initialize of config
          inits.unshift(() => config._api.initialize({ config: this, km: kmFn, ...args, api: config._api }))
          // config._api.initialize({ config, api: config._api })
        } else {
          inits.unshift(null)
        }
        // config._api.objects = namespacedObjects
        // config._api.config = () => this
        // config._api.uuid = config._uuid
      } else {
        inits.unshift(null)
      }
      config.setUUIDs()
      config.applyNamespace(config.config, namespace, config.uuid)
      if (!isSelf) {
        addInternals.unshift(config)
      } else {
        addInternals.unshift(null)
      }
      km.valid()
    })

    const generators = this.config.generators
    const semantics = this.config.semantics
    this.config.generators = []
    this.config.semantics = []

    {
      const base = {
        operators: this.config.operators,
        bridges: this.config.bridges,
        hierarchy: this.config.hierarchy,
        priorities: this.config.priorities,
        associations: this.config.associations,
        words: this.config.words
      }

      this.config.operators = []
      this.config.bridges = []
      this.config.hierarchy = []
      this.config.priorities = []
      this.config.associations = { positive: [], negative: [] }
      this.config.words = initWords({})

      for (let i = 0; i < addInternals.length; ++i) {
        let name
        if (addInternals[i]) {
          this.addInternalR(addInternals[i], true, false, false, true)
          name = addInternals[i].name
        } else {
          // the ones defined in config must come after the ones in the templates
          this.config.generators = generators.concat(this.config.generators)
          this.config.semantics = semantics.concat(this.config.semantics)
          this.addInternalR(base, true, false, false, true)
          name = this.name
        }
        // console.log('name -------------', name)
        if (inits[i]) {
          // greg55
          inits[i]()
        }
        if (initAfterApis[i]) {
          const init = initAfterApis[i]
          init.config.initializerFn({ ...init.args, kms: this.getConfigs(), isAfterApi: true })
        }
        const instance = this.instances.find((instance) => instance.name == name)
        if (instance) {
          await configHelpers.loadInstance(this, instance)
        }
        this.hierarchy.edges = this.config.hierarchy
      }
    }

    this.hierarchy.edges = this.config.hierarchy

    if (!this.isModule) {
      if (this.template || !this.expect_template) {
        await this.fixtures()
      }
    }

    this.valid()
    this.checks()
  }

  nameToUUID (name) {
    return this.configs.find((km) => km._name == name)._uuid
  }

  // name: namespace name
  // others
  //    if undefined namespace applies to first loaded config
  //    if list of name then namespace applied only to those configs
  //    if true then namespace applies to all loaded configs
  /*
  namespace (moreNames, others) {
    const config = this.copy()
    if (!Array.isArray(moreNames)) {
      moreNames = [moreNames]
    }
    config.defaultConfig()

    if (Array.isArray(others)) {
      config.configs.forEach((km) => {
        let config = km.config
        let updateNamespace = false
        if (!(km.config instanceof Config)) {
          config = this
          updateNamespace = true
        }
        if (others.includes(config.config.name)) {
          km.namespace = moreNames.concat(km.namespace)
          if (updateNamespace) {
            config._namespace = moreNames.concat(config._namespace)
          }
        }
      })
    } else if (others) {
      config.configs.forEach((km) => {
        km.namespace = moreNames.concat(km.namespace)
      })
      config._namespace = moreNames.concat(config._namespace)
    } else {
      const km = config.configs[0]
      km.namespace = moreNames.concat(km.namespace)
      config._namespace = moreNames.concat(config._namespace)
    }
    config.rebuild()
    return config
  }
  */

  setupNamespace (km) {
    let config = km.config
    if (!(config instanceof Config)) {
      config = this.initConfig
    }
    const bridges = ((config instanceof Config) ? config.config.bridges : config.bridges) || []
    const ids = Array.from(new Set(bridges.map((bridge) => bridge.id)))
    this.config.namespaces = this.config.namespaces || {}

    this.config.namespaces[km.uuid] = {
      ids,
      namespace: km.namespace
    }
  }

  // config.initializerFn({ config: this, objects, namespace })
  // this goes through all the configs and sets up this.config
  async initializeConfigFromConfigs ({ others, objects, moreNames, callInitializers = true }) {
    // setup the namespace in the configs
    let first = true
    this.configs.forEach((km) => {
      let config = km.config
      if (!(config instanceof Config)) {
        config = this.initConfig
      }
      if (!km.namespace) {
        km.namespace = []
      }
      if (config instanceof Config) {
        // km.namespace = config._namespace
        config = config.initConfig
      }

      const configPrime = _.cloneDeep(config)

      if (Array.isArray(others)) {
        if (others.indexOf(config.name) >= 0) {
          km.namespace = moreNames.concat(km.namespace)
        }
      } else if (others === true || (!others && first)) {
        km.namespace = moreNames.concat(km.namespace)
      }

      this.applyNamespace(configPrime, km.namespace, km.uuid)
      first = false
      this.addInternal(configPrime, { useOldVersion: false, skipObjects: true })
      applyUUID(configPrime, km.uuid)
    })

    // setup the namespaces mapping for passing to the server side

    this.configs.forEach((km) => {
      // const namespace = km.namespace
      // if (true || namespace.length > 0) { this.setupNamespace(km) }
      this.setupNamespace(km)
    })

    // initialize the configs in context

    if (callInitializers) {
      [...this.configs].reverse().forEach(({ namespace, uuid, config, isSelf }) => {
        if (isSelf) {
          config = this
        }
        let nsobjects = objects
        if (namespace) {
          nsobjects = this.pathToNamespace(objects, namespace)
        }
        const km = (name) => this.getConfig(name)
        if (config instanceof Config) {
          config.initializerFn(setupInitializerFNArgs(this, { isModule: this.isModule, currentConfig: config, testConfig: config, objects: nsobjects, namespace, uuid }))
        } else {
          this.initializerFn(setupInitializerFNArgs(this, { isModule: this.isModule, currentConfig: this, testConfig: this, objects: nsobjects, namespace, uuid }))
        }
      })
    }
  }

  applyNamespace (config, namespace, uuid) {
    const toNS = (id) => {
      if (namespace.length === 0) {
        return id
      }
      return `${namespace.join('#')}#${id}`
    }
    /*
    if (config.name) {
      config.name = toNS(config.name)
    }
    */
    /*
    if (config.associations) {
      const map = (associations) => {
        return associations.map((association) => {
          return association.map((id) => [toNS(id[0]), id[1]])
        })
      }
      const associations = config.associations
      if (associations.positive) {
        associations.positive = map(associations.positive)
      }
      if (associations.negative) {
        associations.negative = map(associations.negative)
      }
    }
    */

    if (config.words) {
      const literals = {}
      for (const word in config.words.literals) {
        literals[word] = config.words.literals[word].map((word) => {
          return Object.assign({}, word, { id: toNS(word.id), uuid })
        })
      }
      config.words.literals = literals

      for (const pattern of config.words.patterns) {
        pattern.defs.forEach((def) => {
          def.id = toNS(def.id)
          def.uuid = uuid
        })
      }

      for (const pair of config.words.hierarchy) {
        pair.child = toNS(pair.child)
        pair.parent = toNS(pair.parent)
      }
    }

    if (config.hierarchy) {
      helpers.mapInPlace(config.hierarchy, (h) => {
        if (Array.isArray(h)) {
          return h.map((id) => toNS(id))
        } else {
          h.child = toNS(h.child)
          h.parent = toNS(h.parent)
          return Object.assign({}, h, { child: toNS(h.child), parent: toNS(h.parent) })
        }
      })
    }

    if (config.priorities) {
      let priorities = config.priorities
      priorities = priorities.map((cp) => {
        const { context, choose, ordered } = cp
        const priority = {
          context: context.map((id) => {
            return [toNS(id[0]), id[1]]
          }),
          choose
        }
        if (ordered) {
          priority.ordered = ordered
        }
        return priority
      })
      config.priorities = priorities
    }

    for (const bag of bags) {
      if (config[bag]) {
        config[bag] = config[bag].map((b) => {
          return Object.assign({}, b, { uuid })
        })
      }
    }
  }

  checks () {
    this.checkOperators()
    this.checkBridges()
  }

  checkOperators () {
    if (!this.config.operators) {
      return
    }

    const seen = {}
    for (const operator of this.config.operators) {
      if (seen[operator.pattern]) {
        const key = `${operator.pattern} (namespace: ${operator.uuid})`
        throw new Error(`Operator '${key}' is defined more than once in the operators`)
      }
      seen[operator.pattern] = true
    }
  }

  checkBridges () {
    if (!this.config.bridges) {
      return
    }

    let duplicated = new Set()
    const seen = new Set()
    for (const bridge of this.config.bridges) {
      const id = `${bridge.id}/${bridge.level} (namespace: ${bridge.uuid || this.uuid})`
      if (seen.has(id)) {
        duplicated.add(id)
      } else {
        seen.add(id)
      }
    }
    duplicated = Array.from(duplicated)
    if (duplicated.length > 0) {
      throw new Error(`In the KM ${this.name}, the following operators are duplicated in the bridges: ${duplicated}`)
    }
  };

  get (property) {
    return this.config[property]
  }

  set (property, value) {
    if (!this.config.hasOwnProperty(property)) {
      throw new Error(`Setting invalid property ${property}`)
    }

    // TODO trie
    if (property == 'words') {
      for (const word in value) {
        for (const def of value[word]) {
          if (!def.uuid) {
            throw new Error(`All definitions for '${property}' must have the uuid property set (config.uuid). uuid is missing from ${JSON.stringify(def)} for the word '${word}'`)
          }
        }
      }
    }

    if (['operators', 'bridges'].includes(property)) {
      for (const def of value) {
        if (!def.uuid) {
          throw new Error(`All definitions for '${property}' must have the uuid property set (config.uuid). uuid is missing from ${JSON.stringify(def)}`)
        }
      }
    }

    this.config[property] = value
    // this.configs[0][property] = value
  }

  pathToNamespace (objects, path) {
    let ns = objects
    path = Object.assign([], path)
    while (path.length > 0) {
      const next = path.shift()
      if (!ns[next]) {
        ns[next] = {}
      }
      ns = ns[next]
    }
    return ns
  }

  addEqClass (existing, other) {
    for (const eqClass of this._eqClasses) {
      if (eqClass.includes(other._uuid)) {
        eqClass.push(other._uuid)
      }
    }
  }

  async add (...createConfigs) {
    createConfigs.forEach((createConfig, index) => {
      if (typeof createConfig !== 'function') {
        throw new Error(`Expected add argument number ${index + 1} to be a function that constructs the config. This can happen if you have a loop in your includes. Sorry I am too tired to add a good error message. Good luck! I know you can figure it out. I have confidence in you.`)
      }
    })

    const mores = []
    for (const createConfig of createConfigs) {
      const more = await createConfig()
      if (this.name && this.name == more.name) {
        throw new Error('Cannot add an object to itself for argument number ${index+1}.')
      }
      if (this === more) {
        throw new Error('Cannot add an object to itself.')
      }
      mores.push(more)
    }
    for (let more of mores) {
      this.valid()
      more.valid()
      // copy so i don't have to copy later
      more = await more.copy()
      more.server(this._server, this._key, this._queryParams)

      const moreConfigs = more.configs.map((km) => km.name || km.uuid)
      this.loadOrder.addList(moreConfigs)

      // get the new ones
      // remove the dups
      // run the initialize one all new ones
      // this.configs = this.configs.concat(new KM({config: more}));
      // only set for the first one the rest have it set
      const namespace = this._namespace.concat(more._namespace)
      const moreKMs1 = [new KM({ config: more, getCounter: (name) => this.getCounter(name), uuid: more.uuid, namespace })]
      const moreKMs2 = more.configs.slice(1).map((km) => {
        return km
      })
      const moreKMs = moreKMs1.concat(moreKMs2)
      const eqClass = moreKMs.map((km) => km.uuid)
      this._eqClasses.push(eqClass)
      // look for dups and combine them with the eqclasses
      for (const moreKM of moreKMs) {
        const existingKM = this.configs.find((km) => moreKM._name && km.name === moreKM.name)
        if (existingKM) {
          this.addEqClass(existingKM, moreKM)
        } else {
          this.configs.push(moreKM)
        }
      }
      await more.resetToOne()
      this.config.eqClasses = this._eqClasses
      // greg
      // setup instances
      this.instances = []
      this.configs.forEach((km) => {
        this.instances = (km._config.instances || this.initInstances.slice()).concat(this.instances)
      })
      const noDups = []
      for (const instance of this.instances) {
        if (!noDups.find((existing) => existing.name == instance.name)) {
          noDups.push(instance)
        }
      }
      this.instances = noDups
    }
    await this.rebuild() // in add(
    this.valid()
    return this
  }

  // TODO get rid of useOldVersion arg
  addInternal (more, { uuid, addFirst = false, useOldVersion = true, skipObjects = false, includeNamespaces = true, allowNameToBeNull = false, handleCalculatedProps: hcps = false } = {}) {
    validConfigProps(more)
    if (more instanceof Config) {
      more.initialize({ force: false })
      if (useOldVersion) {
        more = more.config
      } else {
        // more = more.initConfig
        more = _.cloneDeep(more.initConfig)
      }
    }
    debugConfigProps(more)

    if (hcps) {
      handleCalculatedProps(this, more, { addFirst, uuid })
      applyUUID(more, uuid || this._uuid)
    }
    for (const key of Object.keys(more)) {
      const value = more[key]
      // TODO remove name and description on the config bag
      const noOverwrite = ['name', 'namespaced']
      if (!this.config[key]) {
        if (allowNameToBeNull) {
          if (noOverwrite.includes(key)) {
            continue
          }
        } else if (this.config[key] && noOverwrite.includes(key)) {
          continue
        }
        this.config[key] = value
        continue
      }
      if (key === 'words') {
        if (more.words.literals) {
          const literals = this.config.words.literals
          const moreLiterals = more.words.literals
          for (const word of Object.keys(moreLiterals)) {
            if (!literals[word]) {
              literals[word] = []
            }
            if (addFirst) {
              literals[word] = moreLiterals[word].concat(literals[word])
            } else {
              literals[word] = literals[word].concat(moreLiterals[word])
            }
          }
        }
        if (more.words.patterns) {
          const patterns = this.config.words.patterns
          const morePatterns = more.words.patterns
          if (addFirst) {
            this.config.words.patterns = morePatterns.concat(patterns)
          } else {
            this.config.words.patterns = patterns.concat(morePatterns)
          }
        }
        if (more.words.hierarchy) {
          const hierarchy = this.config.words.hierarchy
          const moreHierarchy = more.words.hierarchy
          if (addFirst) {
            this.config.words.hierarchy = moreHierarchy.concat(hierarchy)
          } else {
            this.config.words.hierarchy = hierarchy.concat(moreHierarchy)
          }
        }
      } else if (key === 'name') {
        /*
        if (this.config[key] === '') {
          this.config[key] = more[key]
        }
        */
      } else if (key === 'namespaces') {
        if (includeNamespaces) {
          Object.assign(this.config[key], more[key])
        }
      } else if (key === 'debug') {
        this.config[key] = this.config[key] || more[key]
      } else if (key === 'description') {
        this.config[key] += ' ' + more[key].trim()
      } else if (key === 'objects') {
        if (!skipObjects) {
          // namespaced is special
          const namespaced = this.config.objects.namespaced
          Object.assign(this.config[key], more[key])
          this.config.objects.namespaced = namespaced
        }
      } else if (key === 'associations') {
        const configAssociations = this.config.associations
        const moreAssociations = more.associations
        if (moreAssociations.positive) {
          configAssociations.positive = configAssociations.positive.concat(moreAssociations.positive)
        }
        if (moreAssociations.negative) {
          configAssociations.negative = configAssociations.negative.concat(moreAssociations.negative)
        }
      } else if (Array.isArray(value)) {
        // handle allowDups
        if (key == 'operators') {
          // TODO what about other props
          const isDup = (op1, op2) => op1.pattern == op2.pattern
          for (const newOne of more[key]) {
            for (let iOldOne = 0; iOldOne < this.config[key].length; ++iOldOne) {
              const oldOne = this.config[key][iOldOne]
              if (isDup(newOne, oldOne)) {
                if (oldOne.allowDups) {
                  // the old one takes precedence to match what would happen during the original load
                  this.config[key].splice(iOldOne, 1)
                  break
                }
              }
            }
          }
        }
        if (key == 'bridges') {
          // TODO what about other props
          const idDup = (b1, b2) => b1.id == b2.id && b1.level == b2.level && b1.bridge == b2.bridge
          for (const newOne of more[key]) {
            for (let iOldOne = 0; iOldOne < this.config[key].length; ++iOldOne) {
              const oldOne = this.config[key][iOldOne]
              if (newOne.id == oldOne.id) {
                if (oldOne.allowDups) {
                  // the old one takes precedence to match what would happen during the original load
                  this.config[key].splice(iOldOne, 1)
                  break
                }
              }
            }
          }
        }

        // console.log('key', key, 'XXX')
        // console.log('more', JSON.stringify(more, null, 2))
        // hierarchy must update in place and does not care about the list order
        if (key == 'hierarchy') {
          this.config[key].push(...more[key])
        } else {
          if (addFirst) {
            this.config[key] = more[key].concat(this.config[key])
          } else {
            this.config[key] = this.config[key].concat(more[key])
          }
        }
      } else {
        if (!(key in this.config)) {
          throw new Error(`Unexpected property in config ${key}`)
        }
        this.config[key] = more[key]
      }
    }
    return this
  }

  // assumes this is called in reverse order
  addInternalR (more, useOldVersion = true, skipObjects = false, includeNamespaces = true, allowNameToBeNull = false) {
    if (more instanceof Config) {
      more.initialize23({ force: false })
      if (useOldVersion) {
        more = more.config
      } else {
        // more = more.initConfig
        more = _.cloneDeep(more.initConfig)
      }
    }
    for (const key of Object.keys(more)) {
      const value = more[key]
      // TODO remove name and description on the config bag
      const noOverwrite = ['name', 'namespaced']
      if (!this.config[key]) {
        if (allowNameToBeNull) {
          if (noOverwrite.includes(key)) {
            continue
          }
        } else if (this.config[key] && noOverwrite.includes(key)) {
          continue
        }
        this.config[key] = value
        continue
      }
      if (key === 'words') {
        if (this.config.words.literals) {
          const literals = this.config.words.literals
          const moreLiterals = more.words.literals
          for (const word of Object.keys(moreLiterals)) {
            if (!literals[word]) {
              literals[word] = []
            }
            literals[word] = moreLiterals[word].concat(literals[word])
          }
        }
        if (this.config.words.patterns) {
          const patterns = this.config.words.patterns
          const morePatterns = more.words.patterns
          this.config.words.patterns = morePatterns.concat(patterns)
        }
        if (this.config.words.hierarchy) {
          const hierarchy = this.config.words.hierarchy
          const moreHierarchy = more.words.hierarchy
          this.config.words.hierarchy = moreHierarchy.concat(hierarchy)
        }
      } else if (key === 'name') {
        /*
        if (this.config[key] === '') {
          this.config[key] = more[key]
        }
        */
      } else if (key === 'namespaces') {
        if (includeNamespaces) {
          Object.assign(this.config[key], more[key])
        }
      } else if (key === 'debug') {
        this.config[key] = this.config[key] || more[key]
      } else if (key === 'description') {
        // this.config[key] += ' ' + more[key].trim()
        this.config[key] = more[key].trim() + ' ' + this.config[key]
      } else if (key === 'objects') {
        if (!skipObjects) {
          // namespaced is special
          const namespaced = this.config.objects.namespaced
          Object.assign(this.config[key], more[key])
          this.config.objects.namespaced = namespaced
        }
      } else if (key === 'associations') {
        const configAssociations = this.config.associations
        const moreAssociations = more.associations
        if (moreAssociations.positive) {
          // configAssociations.positive = configAssociations.positive.concat(moreAssociations.positive)
          configAssociations.positive = moreAssociations.positive.concat(configAssociations.positive)
        }
        if (moreAssociations.negative) {
          // configAssociations.negative = configAssociations.negative.concat(moreAssociations.negative)
          configAssociations.negative = moreAssociations.negative.concat(configAssociations.negative)
        }
      } else if (Array.isArray(value)) {
        // handle allowDups
        if (key == 'operators') {
          // TODO what about other props
          const isDup = (op1, op2) => op1.pattern == op2.pattern
          for (const newOne of more[key]) {
            for (let iOldOne = 0; iOldOne < this.config[key].length; ++iOldOne) {
              const oldOne = this.config[key][iOldOne]
              if (isDup(newOne, oldOne)) {
                if (oldOne.allowDups) {
                  // the old one takes precedence to match what would happen during the original load
                  this.config[key].splice(iOldOne, 1)
                  break
                }
              }
            }
          }
        }
        if (key == 'bridges') {
          // TODO what about other props
          const idDup = (b1, b2) => b1.id == b2.id && b1.level == b2.level && b1.bridge == b2.bridge
          for (const newOne of more[key]) {
            for (let iOldOne = 0; iOldOne < this.config[key].length; ++iOldOne) {
              const oldOne = this.config[key][iOldOne]
              if (newOne.id == oldOne.id) {
                if (oldOne.allowDups) {
                  // the old one takes precedence to match what would happen during the original load
                  this.config[key].splice(iOldOne, 1)
                  break
                }
              }
            }
          }
        }
        // console.log('key', key, 'XXX')
        // console.log('more', JSON.stringify(more, null, 2))
        // this.config[key] = this.config[key].concat(more[key])
        // this.config[key] = this.config[key].concat(more[key])
        this.config[key] = more[key].concat(this.config[key])
      } else {
        if (!(key in this.config)) {
          throw new Error(`Unexpected property in config ${key}`)
        }
        this.config[key] = more[key]
      }
    }
    return this
  }
}

module.exports = {
  Config,
  config_toServer,
  operatorKey_valid,
  handleBridgeProps
}
